var React = require('react');

function Quick (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:none;stroke:#000000;stroke-width:6;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n"),React.createElement("polygon",{"points":"107,109 43,109 43,45 85,45 85,51 49,51 49,103 101,103 101,60 107,60 ","key":1}),React.createElement("polygon",{"points":"75.2,90.4 56.5,67.6 61.2,63.8 74.7,80.3 104.5,34.8 109.5,38.1 ","key":2})]);
}

Quick.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 150 150","style":{"enableBackground":"new 0 0 150 150"},"xmlSpace":"preserve"};

module.exports = Quick;

Quick.default = Quick;
